var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg20211101IconMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    display: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "img-arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M21.5 0.5L21.5 23.5 2.5 12z"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    d: "M0 0H24V24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img-arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M2.527 23.505L2.527 0.505 21.5 12.005z"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    d: "M0 0H24V24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img-bookmark-add"
  }, /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 18.5,
    cy: 18.5,
    r: 5,
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M18.5 16L18.5 21"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M21 18.5L16 18.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M7.25 19L19.5 6.5 19.5 0.5 13.242 0.508 1 12.75z"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 16,
    cy: 4,
    r: 1.5,
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    d: "M0 0H24V24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img-bookmark-subtract"
  }, /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 18.5,
    cy: 18.5,
    r: 5,
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M21 18.5L16 18.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M7.25 19L19.5 6.5 19.5 0.5 13.242 0.508 1 12.75z"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 16,
    cy: 4,
    r: 1.5,
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    d: "M0 0H24V24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img-burger-menu"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "square",
    d: "M2 3.6L20 3.6",
    transform: "translate(1)"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "square",
    d: "M2 12L20 12",
    transform: "translate(1)"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "square",
    d: "M2 20.4L20 20.4",
    transform: "translate(1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img-dashboard"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    d: "M37.5,34.1h3.7c1.8,0,3.3,1.5,3.3,3.3v3.8c0,1.8-1.5,3.3-3.3,3.3h-3.7c-1.8,0-3.3-1.5-3.3-3.3 v-3.8C34.1,35.6,35.6,34.1,37.5,34.1z",
    transform: "translate(-21 -21)"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    d: "M24.9,34.1h3.7c1.8,0,3.3,1.5,3.3,3.3 v3.8c0,1.8-1.5,3.3-3.3,3.3h-3.7c-1.8,0-3.3-1.5-3.3-3.3v-3.8C21.6,35.6,23.1,34.1,24.9,34.1z",
    transform: "translate(-21 -21)"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    d: "M37.5,21.5h3.7c1.8,0,3.3,1.5,3.3,3.3 v3.8c0,1.8-1.5,3.3-3.3,3.3h-3.7c-1.8,0-3.3-1.5-3.3-3.3v-3.8C34.1,23,35.6,21.5,37.5,21.5z",
    transform: "translate(-21 -21)"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    d: "M24.9,21.5h3.7c1.8,0,3.3,1.5,3.3,3.3 v3.8c0,1.8-1.5,3.3-3.3,3.3h-3.7c-1.8,0-3.3-1.5-3.3-3.3v-3.8C21.6,23,23.1,21.5,24.9,21.5z",
    transform: "translate(-21 -21)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img-expand"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M15.5 8.5L23.5 0.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M0.5 23.5L8.5 15.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M5.5 23.5L0.5 23.5 0.5 18.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M23.5 5.5L23.5 0.5 18.5 0.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M15.5 15.5L23.5 23.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M0.5 0.5L8.5 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M0.5 5.5L0.5 0.5 5.5 0.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M18.5 23.5L23.5 23.5 23.5 18.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    d: "M0 0H24V24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img-flip"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M0.887,9.5H11.5 c2.209,0,4,1.792,4,4v2"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M4.887 13.5L0.887 9.5 4.887 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M9.5 13L9.5 19.5 23.5 19.5 23.5 5.5 9.5 5.5 9.5 7"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    d: "M0 0H24V24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img-remove"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M23.5 0.5L0.5 23.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M23.5 23.5L0.5 0.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    d: "M0 0H24V24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img-remove-black"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M23.5 0.5L0.5 23.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M23.5 23.5L0.5 0.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    d: "M0 0H24V24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img-shrink"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M15.5 8.5L23.5 0.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M0.5 23.5L8.5 15.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.5 8.5L15.5 8.5 15.5 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8.5 20.5L8.5 15.5 3.5 15.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M15.5 15.5L23.5 23.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M0.5 0.5L8.5 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M15.5 20.5L15.5 15.5 20.5 15.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M3.5 8.5L8.5 8.5 8.5 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    d: "M0 0H24V24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img-source"
  }, /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none",
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 12,
    cy: 12,
    r: 3.5,
    fill: "none",
    stroke: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img-share"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8.074,10.213C7.418,8.902,6.066,8,4.5,8 c-2.209,0-4,1.791-4,4s1.791,4,4,4c1.566,0,2.918-0.902,3.574-2.213"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M19.5,8.5c2.209,0,4-1.791,4-4 s-1.791-4-4-4s-4,1.791-4,4c0,0.643,0.156,1.248,0.425,1.787"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M15.925,17.713 C14.598,20.361,16.523,23.5,19.5,23.5c2.209,0,4-1.791,4-4s-1.791-4-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M19.5,8.5 c-1.566,0-2.918-0.902-3.575-2.213l-7.851,3.926C8.344,10.75,8.5,11.356,8.5,12c0,0.643-0.156,1.248-0.426,1.787l7.851,3.926 c0.657-1.311,2.009-2.213,3.575-2.213"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    d: "M0 0H24V24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20211101IconMap);
export default __webpack_public_path__ + "static/media/2021-11-01-icon-map.ac8d051c7805c3358d0bebde0cc47a79.svg";
export { ForwardRef as ReactComponent };